import { useEffect, useState } from 'react'
import { getDatabase, ref, set, push, onValue, remove } from 'firebase/database'

const useDatabaseHook = (id) => {
  // const [db, setDb] = useState()
  const [token, setToken] = useState()

  // Updates value of token if id is not new or will create a new token

  const db = getDatabase()

  useEffect(() => {
    if (id !== 'new') {
      // console.log('we got an id')
      const tokenRef = ref(db, `Tokens/${id}`)
      const snapRef = onValue(tokenRef, (snapshot) => {
        setToken(snapshot.val())
      })
      return () => {
        snapRef()
      }
    } else {
      setToken({})
    }
  }, [id, db])

  // Putting the db in a stateful variable does not allow for the other useEffect to run properly
  // by taking out the state vairable and calling it like it is now works
  // useEffect(() => {
  //   const tempDB = getDatabase()
  //   setDb(tempDB)
  // }, [])

  // Writes a new token to the DB
  const writeNewToken = async (token, name, startDate, endDate) => {
    // add uuid from firebase id generator
    return await push(ref(db, 'Tokens'), {
      token,
      name,
      startDate,
      endDate
    })
  }

  // Updates token to the db
  const updateToken = async (id, token, name, startDate, endDate) => {
    // add uuid from firebase id generator
    return await set(ref(db, `Tokens/${id}`), {
      token,
      name,
      startDate,
      endDate
    })
  }

  const removeToken = async (id) => {
    return await remove(ref(db, `Tokens/${id}`))
  }

  return {
    writeNewToken,
    updateToken,
    removeToken,
    token
  }
}

export default useDatabaseHook
